module.exports = __webpack_public_path__ + "img/bory-logo.aa9233e9.svg";